// Import the core angular services.
import { Component, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeatureToggleService, RoutingService } from 'app/services';
import { FeatureManagerService } from 'app/services/global/feature-manager/feature-manager.service';

import { ViewQueuesComponent } from '../new-business-workbench/view-queues/view-queues.component';
import { ManagementQueuesComponent } from './management-queues.component';
import { FeatureToggle } from '@Enums';
import { ViewQueuesOptimizedComponent } from '@CNBW/view-queues/optimized/view-queues.component';


// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

@Component({
    selector: 'app-projects-switcher',
    styles: [`:host { display: none; }`],
    template:`<!-- Switcher for Projects variations. -->`
})
export class ManagementQueuesSwitcherComponent {

    isQueueViewPerformanceOptimizationEnabled: boolean = false;
    
    constructor(
    private featureManagerService: FeatureManagerService,
    private featureToggleService: FeatureToggleService,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private activatedRoute: ActivatedRoute,
    private routingService: RoutingService
    ) {
        this.activatedRoute.data.subscribe(data => {
            const uniqueClientIds = [...new Set<string>(data.accounts.map(item => item.clientId))];
            const hasSingleClient = uniqueClientIds.length == 1;
            const cnbwEnabled = this.featureManagerService.getByName('Global.CaseManager.V2')?.enabled;
            const useCNBWPage = hasSingleClient && cnbwEnabled;

            // CNBW is disabled globally
            if (!useCNBWPage)
            {
                this.viewContainerRef.createComponent(ManagementQueuesComponent);
                return;
            }
            this.featureManagerService.isEnabled(FeatureToggle.GlobalCaseManagerQueueViewPerformanceOptimization).subscribe(isEnabled => {
                this.isQueueViewPerformanceOptimizationEnabled = isEnabled;

                this.featureToggleService.getFeatureFlag('Global.CaseManager.V2.Client', uniqueClientIds[0]).subscribe(clientHasAccessToCNBW => {
                    if (clientHasAccessToCNBW) {
                        if (this.isQueueViewPerformanceOptimizationEnabled) {
                            const viewQueuesComponent = this.viewContainerRef.createComponent(ViewQueuesOptimizedComponent);
                            viewQueuesComponent.instance.clientId = uniqueClientIds[0];
                        }else{
                            const viewQueuesComponent = this.viewContainerRef.createComponent(ViewQueuesComponent);
                            viewQueuesComponent.instance.clientId = uniqueClientIds[0];
                        }
                    }
                    else {
                        this.viewContainerRef.createComponent(ManagementQueuesComponent);
                    }
                });                
            });
        });
    }
}
